






















import Vue from "vue";
import Component from "vue-class-component";
import ChatBotDrawer from "@/components/Ai/ChatBotDrawerMcp.vue";

@Component({
    components: {
        ChatBotDrawer,
    },
})
export default class ChatBotMcp extends Vue {
    private isOpened: boolean = false;
}
